import HttpService from '../../misc/HttpService/HttpService';
import getAccountDetailsApiUrl from './getAccountDetailsApiUrl';
import getAccountsApiUrl from './getAccountsApiUrl';
import getAccountTypesApiUrl from './getAccountTypesApiUrl';
import getAssetTypeApiUrl from './getAssetTypeApiUrl';
import getEndpointDetailsApiUrl from './getEndpointDetailsApiUrl';
import getEndpointsApiUrl from './getEndpointsApiUrl';
import getListRowApiUrl from './getListRowApiUrl';
import getPlatformTypeApiUrl from './getPlatformTypeApiUrl';

export const getPlatformTypeApi = () =>
  HttpService.get(getPlatformTypeApiUrl()).then((response) => response);

export const getAssetTypeApi = () =>
  HttpService.get(getAssetTypeApiUrl()).then((response) => response);

export const getAccountTypesApi = () =>
  HttpService.get(getAccountTypesApiUrl()).then((response) => response);

export const getAccountDetailsApi = (accountKey) =>
  HttpService.get(getAccountDetailsApiUrl(accountKey)).then(
    (response) => response
  );

export const getListRowApi = () =>
  HttpService.post(getListRowApiUrl(), {}).then((response) => response);

export const getEndpointsApi = (request, errorCallback) =>
  HttpService.post(getEndpointsApiUrl(), request, errorCallback);

export const getEndpointDetailsApi = (endpointKey) =>
  HttpService.get(getEndpointDetailsApiUrl(endpointKey)).then(
    (response) => response
  );

export const getListRowApiFilterAndSearch = (
  platformTypes,
  assetTypes,
  search
) => {
  const filterBy = {};

  if (platformTypes.length > 0) {
    filterBy.platformTypes = platformTypes;
  }

  if (assetTypes.length > 0) {
    filterBy.assetTypes = assetTypes;
  }

  return HttpService.post(getListRowApiUrl(), {
    filterBy,
    findBy: search,
  }).then((response) => response);
};

export const getAccountListApi = () =>
  HttpService.post(getAccountsApiUrl(), { filterBy: { endpointKeys: [4] }, }).then((response) => response);
